module.exports = __webpack_public_path__ + "static/media/w_w_hb_12.2eb882f6.png";